<template>
  <div class="user-edit-wrapper">
    <el-form
      :loading="submiting"
      :model="userForm"
      :rules="formRules"
      label-position="top"
      ref="userForm"
      class="user-form"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="账号名称:" :class="isUserIdExist ? 'is-error':''" prop="id">
            <el-input
              class="form-input"
              v-model.trim="userForm.id"
              placeholder="请输入账号名称"
              @input="checkID"
              clearable
            ></el-input>
            <div class="is-id-exist el-form-item__error" v-if="isUserIdExist">该账户已存在</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户姓名:" prop="name">
            <el-input class="form-input" v-model.trim="userForm.name" placeholder="请输入用户姓名" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="客户:" prop="clientId">
            <el-select class="form-input" v-model="userForm.clientId" placeholder="请选择客户" clearable>
              <el-option
                v-for="item in clientOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="部门:" prop="departmentId">
            <el-select class="form-input" v-model="userForm.departmentId" placeholder="请选择部门" clearable>
              <el-option
                v-for="item in departmentOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否在招商筛选中显示:" prop="showInMerchantFilter">
            <el-checkbox v-model="userForm.showInMerchantFilter" border>{{userForm.showInMerchantFilter ? '显示' : '隐藏'}}</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="用户角色:" prop="roles">
            <el-checkbox-group v-model="userForm.roles">
              <el-checkbox
                class="role-item"
                v-for="role in rolesOptions"
                :label="role.id"
                :key="role.id"
              >{{role.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item style="text-align:right">
            <el-button
              type="primary"
              size="small"
              v-if="formType === 'add'"
              @click="onSubmit('userForm')"
            >立即创建</el-button>
            <el-button
              type="primary"
              size="small"
              v-if="formType === 'edit'"
              @click="onEdit('userForm')"
            >提交修改</el-button>
            <el-button size="small" @click="onFormCancel">取消</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: [String, Array],
      default: ""
    },
    formType: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      submiting: false,
      userForm: {
        id: "",
        name: "",
        clientId: "",
        departmentId: null,
        showInMerchantFilter: false,
        roles: []
      },
      clientOptions: [],
      departmentOptions: [],
      rolesOptions: [],
      formRules: {
        id: [{ required: true, message: "请输入账号名称", trigger: "blur" }
        // { pattern: /^[a-zA-Z]\w{5,17}$/, message: '以字母开头，长度在6-18之间，只能包含字符、数字和下划线' }
        ],
        name: [{ required: true, message: "请输入用户姓名", trigger: "blur" }],
        roles: [
          { required: true, message: "用户角色不能为空", trigger: "change" }
        ]
      },
      isUserIdExist: false
    };
  },
  created() {
    this.getClientOptions();
    this.getDepartmentOptions();
    this.getRolesOptions();
    if(this.formType === 'edit'){
      this.getUserDetail(this.userId)
    }
  },
  methods: {
    getUserDetail(id) {
      this.loading = true;
      this.$api
        .get(`/users/${id}`)
        .then(res => {
          if (res.status === 200) {
            for(let key in this.userForm){
              if(res.data[key]){
                this.userForm[key] = res.data[key]
              }
            }
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    getClientOptions() {
      this.$api
        .get(`/users/clients/selections`)
        .then(res => {
          if (res.status === 200) {
            this.clientOptions = res.data;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    getDepartmentOptions() {
      this.$api
        .get(`/departments`, {
          params: {
            unPaged: true
          }
        })
        .then(res => {
          if (res.status === 200 || res.status === 206) {
            this.departmentOptions = res.data.content;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    getRolesOptions() {
      this.$api
        .get(`/users/roles/selections`)
        .then(res => {
          if (res.status === 200) {
            this.rolesOptions = res.data;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    /**
     * 移除角色
     */
    onRoleCancel(role) {
      console.log("role", role);
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && !this.isUserIdExist) {
          this.submiting = true;
          this.$api
            .post(`/users`, this.userForm)
            .then(res => {
              if (res.status === 200 || res.status === 201) {
                this.submiting = false;
                this.initForm()
                this.$emit('onSuccess')
                this.$message.success("提交成功");
              }
            })
            .catch(err => {
              this.submiting = false;
              console.log(err.response);
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onEdit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && !this.isUserIdExist) {
          this.submiting = true;
          this.$api
            .put(`/users/${this.userId}`, this.userForm)
            .then(res => {
              if (res.status === 201 || res.status === 204) {
                this.submiting = false;
                this.initForm()
                this.getUserDetail(this.userId)
                this.$emit('onSuccess')
                this.$message.success("修改成功");
              }
            })
            .catch(err => {
              this.submiting = false;
              console.log(err.response);
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onFormCancel(){
      this.initForm()
      this.$emit('cancel')
    },
    // 用户账号查重
    checkID(val) {
      this.checkUserIdIsexist(val);
    },
    // 账号查重api
    checkUserIdIsexist(userId) {
      this.$api
        .get(`/users/existence?userId=${userId}`)
        .then(res => {
          if (res.status === 200) {
            this.isUserIdExist = res.data;
          }
        })
        .catch(err => {
          this.isUserIdExist = false;
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    initForm() {
      this.userForm = {
        id: "",
        name: "",
        clientId: "",
        roles: []
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.user-edit-wrapper {
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  padding: 15px;
  .form-input {
    width: 100%;
  }
  .is-id-exist {
    right: 0;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #f56c6c;
    text-align: right;
    overflow: hidden;
  }
  .role-item{
    width: 200px;
  }
}
</style>